import { PayoutOrderListFilterFormData } from '@/models/payout-order/payout-order-list-filter.model';
import { OptionItem } from '@/models/common/option-item';

export const DEFAULT_PAYOUT_ORDER_LIST_FILTER_FORM_DATA: PayoutOrderListFilterFormData = {
  tagList: [],
  tagIdListCondition: '',
  segmentList: [],
  segmentIdListCondition: '',
  applicationStatus: 'pending',
  processingType: 'manual',
  playerEmail: '',
  payoutStatus: '',
  countryList: [],
  countryListCondition: '',
  paymentSystemList: [],
  paymentSystemListCondition: '',
};

export const DEFAULT_CONDITION_LIST: OptionItem[] = [
  { label: 'And', value: 'and' },
  { label: 'Or', value: 'or' },
  { label: 'Except', value: 'except' },
];

export const EXCLUDE_AND_CONDITION_LIST: OptionItem[] = [
  { label: 'Or', value: 'or' },
  { label: 'Except', value: 'except' },
];

export const TRANSACTION_STATUSES_LIST: OptionItem[] = [
  { label: 'Pending', value: 'pending' },
  { label: 'Hold', value: 'hold' },
];

export const PROCESSING_TYPE_LIST: OptionItem[] = [
  { label: 'Auto', value: 'auto' },
  { label: 'Manual', value: 'manual' },
];

export const PAYOUT_STATUS_LIST: OptionItem[] = [
  { label: 'Taken', value: 'taken' },
  { label: 'Not taken', value: 'notTaken' },
];
